<script setup lang="ts">
import BarcodeWithPinForm from './components/BarcodeWithPinForm.vue'
import ResultForm from './components/ResultForm.vue'
import CollapsibleItem from './components/CollapsibleItem.vue'

const { VITE_APP_TITLE } = import.meta.env

import { ref, shallowRef } from 'vue'
import type { Component } from 'vue'

type Step = {
  component: Component
  enabled: boolean
}

let steps: Step[] = [
  { component: BarcodeWithPinForm, enabled: true },
  { component: ResultForm, enabled: false }
]

let step = ref(0)

let component = shallowRef(steps[step.value].component)

function changeStep(direction: number) {
  step.value = (step.value + direction) % steps.length
  steps[step.value].enabled = true
  component.value = steps[step.value].component
  if (step.value == steps.length - 1) {
    for (let i = 0; i < steps.length - 1; i++) {
      steps[i].enabled = false
    }
  }
}

function handleNext() {
  changeStep(+1)
}

// function handlePrevious() {
//   changeStep(-1);
// }

function onStepClick(idx: number) {
  let isEnabled = steps[idx].enabled
  if (isEnabled) {
    step.value = idx
  }
}
</script>

<template>
  <div class="page">
    <main class="content">
      <header class="flex items-center divide-x space-x-4">
        <img src="/logo_full.png" class="h-12" alt="Lundoch Diagnostics logo" />
        <div class="pl-4">
          <div class="lg:text-2xl text-lg sm:text-xl dark:text-gray-300">{{ VITE_APP_TITLE }}</div>
        </div>
      </header>
      <div class="">
        <div class="">
          <div
            class=""
            v-bind:key="idx"
            v-for="(s, idx) in steps"
            :value="idx"
            :disabled="!s.enabled"
          >
            <CollapsibleItem
              :enabled="s.enabled"
              :expanded="step == idx"
              @on-click-title="() => onStepClick(idx)"
            >
              <component :is="s.component" @on-click-next="handleNext" />
            </CollapsibleItem>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<style scoped></style>
